import { ROUTES } from "@via/utils/constants.tsx";

/**
 * The run environments page's deep link (agent-4-2, spec 3G-3b A4): `?environment=<id>` opens that
 * environment's form at its Agent card. One module for both ends, so the refusal panel that writes the
 * link and the page that reads it cannot disagree on the parameter.
 */
export const ENVIRONMENT_SEARCH_PARAM = "environment";

/** The id in `?environment=<id>`, or null for anything that is not a plain positive whole number. */
export const environmentIdFromSearch = (
  search: URLSearchParams
): number | null => {
  const raw = search.get(ENVIRONMENT_SEARCH_PARAM);
  if (null === raw || !/^[1-9][0-9]{0,9}$/.test(raw)) return null;
  return Number(raw);
};

/** The run environments page, opened at one environment when its id is known. */
export const runEnvironmentDeepLink = (
  environmentId: number | null | undefined
): string =>
  undefined === environmentId ||
  null === environmentId ||
  !Number.isInteger(environmentId) ||
  environmentId <= 0
    ? ROUTES.RUN_ENVIRONMENTS
    : `${ROUTES.RUN_ENVIRONMENTS}?${ENVIRONMENT_SEARCH_PARAM}=${environmentId}`;
